export default "__VITE_ASSET__DxF05YQc__"